(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comely-faq-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.toLocaleLowerCase().replace(/\s+/g, ' ').trim();

    const initialize = (root) => {
      if (root.dataset.faqSearchReady === 'true') return;

      const input = root.querySelector('[data-comely-faq-search-input]');
      const clearButton = root.querySelector('[data-comely-faq-search-clear]');
      const status = root.querySelector('[data-comely-faq-search-status]');
      const empty = root.querySelector('[data-comely-faq-search-empty]');
      const sectionIds = (root.dataset.faqSectionIds || '').split(',').filter(Boolean);
      const groups = sectionIds
        .map((id) => document.querySelector(`[id$="__${id}"]`))
        .filter(Boolean)
        .map((section) => ({
          section,
          items: Array.from(section.querySelectorAll('hdt-accordion')),
        }));

      if (!input || !clearButton || !status || !empty || !groups.length) return;

      const total = groups.reduce((count, group) => count + group.items.length, 0);
      const label = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

      const update = () => {
        const query = normalize(input.value);
        let matches = 0;

        groups.forEach((group) => {
          let groupMatches = 0;

          group.items.forEach((item) => {
            const isMatch = !query || normalize(item.textContent).includes(query);
            item.hidden = !isMatch;
            item.toggleAttribute('data-comely-faq-filter-hidden', !isMatch);
            if (isMatch) groupMatches += 1;
          });

          const hideGroup = Boolean(query) && groupMatches === 0;
          group.section.hidden = hideGroup;
          group.section.toggleAttribute('data-comely-faq-filter-hidden', hideGroup);
          matches += groupMatches;
        });

        clearButton.hidden = !query;
        empty.hidden = !query || matches > 0;
        status.textContent = query
          ? label(matches, status.dataset.resultSingular, status.dataset.resultPlural)
          : label(total, status.dataset.questionSingular, status.dataset.questionPlural);
      };

      const clear = () => {
        input.value = '';
        update();
        input.focus();
      };

      root.addEventListener('submit', (event) => event.preventDefault());
      input.addEventListener('input', update);
      input.addEventListener('search', update);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value) {
          event.preventDefault();
          clear();
        }
      });
      clearButton.addEventListener('click', clear);

      root.dataset.faqSearchReady = 'true';
      update();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-comely-faq-search]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comely-logo-customization"]) return;
  try {
    
function initLogoFees() {
  document.querySelectorAll('[data-logo-fee]').forEach(root => {
    if (root.dataset.logoReady) return;
    root.dataset.logoReady = 'true';
    const form = root.querySelector('form');
    const file = root.querySelector('[data-logo-file]');
    const quantity = form.elements.quantity;
    const total = root.querySelector('[data-logo-total]');
    const preview = root.querySelector('[data-logo-preview]');
    const image = root.querySelector('[data-logo-image]');
    const error = root.querySelector('[data-logo-error]');
    const button = root.querySelector('[data-logo-submit]');
    const initialText = button.textContent;
    const initiallyDisabled = button.disabled;
    let previewUrl;
    const clearPreview = () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = undefined;
      image.removeAttribute('src');
      preview.hidden = true;
    };
    const updateFile = () => {
      clearPreview();
      file.setCustomValidity('');
      error.hidden = true;
      error.textContent = '';
      const chosen = file.files[0];
      if (!chosen) return;
      let message = '';
      if (!/\.(png|jpe?g)$/i.test(chosen.name) || (chosen.type && !['image/png', 'image/jpeg'].includes(chosen.type))) message = file.dataset.typeError;
      else if (chosen.size > 10 * 1024 * 1024 || chosen.size === 0) message = file.dataset.sizeError;
      if (message) {
        file.setCustomValidity(message);
        error.textContent = message;
        error.hidden = false;
        return;
      }
      root.querySelector('[data-logo-filename]').textContent = chosen.name;
      previewUrl = URL.createObjectURL(chosen);
      image.src = previewUrl;
      preview.hidden = false;
    };
    const updateTotal = () => {
      const value = Number(quantity.value);
      const valid = quantity.validity.valid && Number.isInteger(value) && value > 0;
      total.textContent = valid ? new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency }).format(value * Number(root.dataset.unitPrice) / 100) : '—';
    };
    file.addEventListener('change', updateFile);
    root.querySelector('[data-logo-remove]').addEventListener('click', () => { file.value = ''; updateFile(); file.focus(); });
    quantity.addEventListener('input', updateTotal);
    form.addEventListener('submit', event => {
      if (!form.reportValidity()) { event.preventDefault(); return; }
      button.disabled = true;
      button.textContent = button.dataset.loading;
    });
    window.addEventListener('pageshow', () => { button.disabled = initiallyDisabled; button.textContent = initialText; updateFile(); updateTotal(); });
    updateTotal();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLogoFees, { once: true });
else initLogoFees();
document.addEventListener('shopify:section:load', initLogoFees);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping"] && !Shopify.designMode) return;
  try {
    
  const initializeBenefitsMarquees = (root = document) => {
    const marquees = root.matches?.('[data-benefits-marquee]')
      ? [root]
      : root.querySelectorAll('[data-benefits-marquee]');

    marquees.forEach((marquee) => {
      if (marquee.dataset.marqueeReady === 'true') return;

      const track = marquee.querySelector('[data-benefits-marquee-track]');
      const items = track ? Array.from(track.children) : [];
      if (items.length < 2) return;

      marquee.style.setProperty('--hdt-benefits-count', items.length);

      const group = document.createElement('div');
      group.className = 'hdt-benefits-marquee__group';
      items.forEach((item) => group.appendChild(item));

      const clone = group.cloneNode(true);
      clone.classList.add('hdt-benefits-marquee__clone');
      clone.setAttribute('aria-hidden', 'true');

      const idMap = new Map();
      clone.querySelectorAll('[id]').forEach((element) => {
        const originalId = element.id;
        const cloneId = `${originalId}--marquee-clone`;
        idMap.set(originalId, cloneId);
        element.id = cloneId;
      });
      clone.querySelectorAll('style').forEach((style) => {
        idMap.forEach((cloneId, originalId) => {
          style.textContent = style.textContent.replaceAll(`#${originalId}`, `#${cloneId}`);
        });
      });
      clone.querySelectorAll('[hdt-reveal], [timeline]').forEach((element) => {
        element.removeAttribute('hdt-reveal');
        element.removeAttribute('timeline');
      });
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      track.append(group, clone);
      track.classList.add('hdt-benefits-marquee__track');
      marquee.dataset.marqueeReady = 'true';

      const updateWidth = () => {
        marquee.style.setProperty('--hdt-benefits-marquee-width', `${marquee.clientWidth}px`);
      };
      updateWidth();
      new ResizeObserver(updateWidth).observe(marquee);
    });
  };

  initializeBenefitsMarquees();
  document.addEventListener('shopify:section:load', (event) => {
    initializeBenefitsMarquees(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
